function* rangeGenerator(start: number, end: number, interval = 1) {
  for (let i = start; i <= end; i += interval) {
    yield i
  }
}

/**
 * 指定した範囲の配列を生成する
 */
export const range = (
  start: number,
  end: number,
  interval = 1
): readonly number[] => {
  return [...rangeGenerator(start, end, interval)]
}
